
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
import { useLanguagePath } from "@/utils/language";
import { useTranslations } from "@/hooks/useTranslations";

export const DashboardHeader = () => {
  const { getPath } = useLanguagePath();
  const { t } = useTranslations("student");
  
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 pb-4 border-b border-slate-100/50 dark:border-gray-700/50 mb-6 animate-fade-in">
      <div className="space-y-2">
        <h2 className="text-3xl font-bold tracking-tight gradient-text text-slate-950 dark:text-slate-50">{t("overview.title")}</h2>
        <p className="text-muted-foreground">{t("overview.subtitle")}</p>
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink href={getPath("/student-dashboard")} className="text-flame hover:text-flame/80">{t("overview.dashboard")}</BreadcrumbLink>
            </BreadcrumbItem>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="font-medium">{t("overview.overview")}</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </div>
    </div>
  );
};
